import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const ParkinsonsDisease = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Parkinson's Disease
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6 text-center"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              When Thinking Slows Down Before Movement Does
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Ask most people what Parkinson's disease looks like and they'll probably
                  describe a tremor. A shaking hand. A shuffling gait. A face that seems
                  less expressive than before. And they'd be right. But what if some of
                  the most important symptoms of Parkinson's disease are invisible? What if,
                  long before movement becomes difficult, the disease is already changing
                  the way people think?
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  For much of the twentieth century, Parkinson's disease was viewed almost
                  entirely as a movement disorder. It was only when neuroscientists began
                  looking more closely at the cognitive changes experienced by patients
                  that a much richer — and more troubling — picture emerged.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  One of the most surprising discoveries was that many people with
                  Parkinson's disease struggle with executive functions such as planning,
                  attention, cognitive flexibility, and decision-making. Yet the nature of
                  those difficulties is often subtle.
                </p>

              </div>

              {/* right image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/parkinsons_disease.png"
                  alt="Parkinson's disease"
                  className="w-full max-w-[600px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">

            <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Unlike patients with damage to the
                  frontal lobes, who may make impulsive decisions and charge ahead without
                  a plan, people with Parkinson's disease often do the opposite. They can
                  spend a long time planning, thinking, and reconsidering before eventually
                  arriving at the right answer.
                </p>
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                It's as if the brain's internal planning machinery is still working but
                has become stuck in a lower gear. This insight led to one of the most
                important lessons neuroscience has taught us about executive function:
                the frontal lobes don't work alone.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Deep inside the brain lies a collection of structures called the basal
                ganglia. These ancient regions communicate constantly with the frontal
                lobes, helping to translate thoughts into actions, plans into behaviour,
                and intentions into reality. Parkinson's disease damages this
                communication network by reducing the supply of dopamine, a
                neurotransmitter that acts as one of the brain's most important chemical
                messengers.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                The result isn't simply slower movement. It can also mean slower
                thinking, reduced flexibility, impaired planning, and difficulties
                adapting to change. In other words, Parkinson's disease provides a
                remarkable window into how executive function really works.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover how Parkinson's
                disease helped reveal the hidden networks that support executive
                function, why dopamine is about much more than movement and "feeling
                good", how studying patients transformed our understanding of planning
                and attention, and what Parkinson's disease can teach all of us about
                the remarkable machinery that allows us to think ahead, stay focused,
                and turn intentions into actions. Because Parkinson's disease isn't
                simply a disorder of movement. It's a disorder that reveals how thought
                itself gets moving.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK HERE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ParkinsonsDisease;